import * as yup from "yup";

import { getHintMaxLength } from "../utils";
/**
 * Hint Settings Validation Schema
 * 所有語言統一字數上限驗證
 */

export const hintValidationSchema = (t: (key: string, options?: { max?: number }) => string) => {
    const maxLength = getHintMaxLength();

    const optionSchema = yup.string().test("max-length", function (value) {
        if (!value || value.trim() === "") return true;
        if (value.length > maxLength) {
            return this.createError({
                message: t("APPWIDGET.HINT_VALIDATION_MAX_LENGTH", {
                    max: maxLength,
                }),
            });
        }
        return true;
    });

    return yup.object().shape({
        hints_icon: yup.string().oneOf(["finger", "speaker"]).required(),
        hints: yup.array().of(
            yup.object().shape({
                language: yup.string().required(t("APPWIDGET.HINT_VALIDATION_LANGUAGE_REQUIRED")),
                option1: optionSchema,
                option2: optionSchema,
                option3: optionSchema,
            })
        ),
    });
};
